import { mainAxios, axiosClouth, axiosAuth } from '../../../src/config/apiConfig'
import { Buffer } from "buffer";
import {  
    REGISTER_FAILURE, 
    REGISTER_REQUEST, 
    REGISTER_SUCCESS,
    LOGIN_FAILURE, 
    LOGIN_REQUEST, 
    LOGIN_SUCCESS, 
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_FAILURE,
    LOGOUT,
    GET_ALL_USER_REQUEST,
    GET_ALL_USER_SUCCESS,
    GET_ALL_USER_FAILURE,
    VRFYACCTS_REQUEST,
    VRFYACCTS_SUCCESS,
    VRFYACCTS_FAILURE,
    CHANGE_USER_PROFILE_REQUEST,
    CHANGE_USER_PROFILE_SUCCESS,
    CHANGE_USER_PROFILE_FAILURE,
    GET_BUSINESSENTITY_REQUEST,
    GET_BUSINESSENTITY_SUCCESS,
    GET_BUSINESSENTITY_FAILURE,
    CHG_USER_ROLE_REQUEST,
    CHG_USER_ROLE_SUCCESS,
    CHG_USER_ROLE_FAILURE,
    SEND_OTP_FRGTP_REQUEST,
    SEND_OTP_FRGTP_SUCCESS,
    SEND_OTP_FRGTP_FAILURE,
    CHANGE_FRGTP_REQUEST,
    CHANGE_FRGTP_SUCCESS,
    CHANGE_FRGTP_FAILURE} from "./ActionType"

//const accessToken=localStorage.getItem("jwt");
const registerRequest=()=>({type:REGISTER_REQUEST});
const registerSuccess=(user)=>({type:REGISTER_SUCCESS, payload:user});
const registerFailure=(error)=>({type:REGISTER_FAILURE, payload:error});

export const register=(userData)=>async (dispatch)=>{

    dispatch(registerRequest())
    
    try{
        const response=await mainAxios.post(`/api/v1/auth/register`,userData)
        const user=response.data;
        if(user==='Success'){
            localStorage.setItem("Result",user);
        }
        //console.log("user- ", user)
        dispatch(registerSuccess(user))
    }catch (error) {
        dispatch(registerFailure(error.message))
    }
}

const sendOTPFrgtPRequest=()=>({type:SEND_OTP_FRGTP_REQUEST});
const sendOTPFrgtPSuccess=(user)=>({type:SEND_OTP_FRGTP_SUCCESS, payload:user});
const sendOTPFrgtPFailure=(error)=>({type:SEND_OTP_FRGTP_FAILURE, payload:error});

export const sendOTPFrgtPassword=(userData)=>async (dispatch)=>{

    dispatch(sendOTPFrgtPRequest())
    //console.log("VrfyData-",userData.reqJWT);
    try{
        const response=await mainAxios.post(`/api/v1/auth/sendOTPFrgtPwd`,null,{
            headers:{
                Authorization: `Bearer ${userData.reqJWT}`,
            },
        });
        const user=response.data;
        //console.log("user- ", user)
        dispatch(sendOTPFrgtPSuccess(user))
    }catch (error) {
        dispatch(sendOTPFrgtPFailure(error.message))
    }
}

const vrfyAcctsRequest=()=>({type:VRFYACCTS_REQUEST});
const vrfyAcctsSuccess=(user)=>({type:VRFYACCTS_SUCCESS, payload:user});
const vrfyAcctsFailure=(error)=>({type:VRFYACCTS_FAILURE, payload:error});

export const vrfyAccts=(userData)=>async (dispatch)=>{

    dispatch(vrfyAcctsRequest())
    //console.log("VrfyData-",userData);
    try{
        const response=await mainAxios.post(`/api/v1/auth/verifyOTP`,userData.otpdata)
        const user=response.data;
        if(user==='Success'){
            localStorage.setItem("Result",user);
        }
        //console.log("user- ", user)
        dispatch(vrfyAcctsSuccess(user))
    }catch (error) {
        dispatch(vrfyAcctsFailure(error.message))
    }
}

const chgPassowrdRequest=()=>({type:CHANGE_FRGTP_REQUEST})
const chgPasswordSuccess=(user)=>({type:CHANGE_FRGTP_SUCCESS, payload:user})
const chgPasswordFailure=(error)=>({type:CHANGE_FRGTP_FAILURE, payload:error})

export const chgPassowrd=(userData)=>async (dispatch)=>{

    dispatch(chgPassowrdRequest())
    //console.log("VrfyData-",userData.reqJWT);
    try{
        const response=await mainAxios.post(`/api/v1/auth/chgPassword`,userData.passwordData,{
            headers:{
                Authorization: `Bearer ${userData.reqJWT}`,
            },
        });
        const user=response.data;
        //console.log("user- ", user)
        dispatch(chgPasswordSuccess(user))
    }catch (error) {
        dispatch(chgPasswordFailure(error.message))
    }
}

const loginRequest=()=>({type:LOGIN_REQUEST});
const loginSuccess=(user)=>({type:LOGIN_SUCCESS, payload:user});
const loginFailure=(error)=>({type:LOGIN_FAILURE, payload:error});

export const login=(userData)=>async (dispatch)=>{

    dispatch(loginRequest())
    
    try{
        //const response=await mainAxios.post(`/api/v1/auth/register`,userData)
        //const user=response.data;
        //if(userData.access_token){
            //localStorage.setItem("jwt",userData.access_token);
        //}
        //console.log("user- ", userData)
        dispatch(loginSuccess(userData))

    }catch (error) {
        dispatch(loginFailure(error.message))
    }
    
}

const chgUserProfileRequest=()=>({type:CHANGE_USER_PROFILE_REQUEST});
const chgUserProfileSuccess=(user)=>({type:CHANGE_USER_PROFILE_SUCCESS, payload:user});
const chgUserProfileFailure=(error)=>({type:CHANGE_USER_PROFILE_FAILURE, payload:error});

export const chgUserProfile=(reqData)=>async (dispatch)=>{
    //console.log("UserProfile=",reqData)
    dispatch(chgUserProfileRequest())
    try{
        const response = await axiosClouth.post(`/api/users/changeUserType`,reqData.profileData,{
            headers:{
                "Authorization":`Bearer ${reqData.reqJWT}`
              }
        })
        const user = response.data;
        dispatch(chgUserProfileSuccess(user));
    }catch (error){
        const errorMessage = error.message;
        //console.log(error)
        dispatch(chgUserProfileFailure(errorMessage));
    }

}

const getBusinessEntityRequest=()=>({type:GET_BUSINESSENTITY_REQUEST});
const getBusinessEntitySuccess=(entity)=>({type:GET_BUSINESSENTITY_SUCCESS, payload:entity});
const getBusinessEntityFailure=(error)=>({type:GET_BUSINESSENTITY_FAILURE, payload:error});

export const getBusinessEntityProfile=(reqData)=>async (dispatch)=>{
    //console.log("BusinessEntity=",reqData)
    dispatch(getBusinessEntityRequest())
    try{
        const response = await axiosClouth.get(`/api/users/getBusinessEntity`,{
            headers:{
                "Authorization":`Bearer ${reqData.reqJWT}`
              }
        })
        const entity = response.data;
        dispatch(getBusinessEntitySuccess(entity));
        //console.log("ProfileData-",entity);
    }catch (error){
        const errorMessage = error.message;
        //console.log(error)
        dispatch(getBusinessEntityFailure(errorMessage));
    }

}


//  get user from token
export const getAllCustomers = (reqData) => {
    return async (dispatch) => {
      //console.log("jwt - ",reqData)
      dispatch({ type: GET_ALL_USER_REQUEST });
      try {
        //const response = await axiosClouth.get(`/api/admin/users`,{
        const response = await axiosClouth.get(`/api/users/profileList?emailId=${reqData.emailId}`,{
          headers:{
            "Authorization":`Bearer ${reqData.reqJWT}`
          }
        });
        const users = response.data;
        dispatch({ type: GET_ALL_USER_SUCCESS, payload: users });
        //console.log("All Customers",users)
      } catch (error) {
        const errorMessage = error.message;
        //console.log(error)
        dispatch({ type: GET_ALL_USER_FAILURE, payload: errorMessage });
      }
    };
};


const getUserRequest=()=>({type:GET_USER_REQUEST});
const getUserSuccess=(user)=>({type:GET_USER_SUCCESS, payload:user});
const getUserFailure=(error)=>({type:GET_USER_FAILURE, payload:error});

export const getUser=(userData)=>async (dispatch)=>{
    //console.log("JWT511- ", localStorage.getItem("jwt"))
    const jwt=userData?.accessToken;
    dispatch(getUserRequest())
    //console.log("AccessToken- ",jwt);
    //console.log("Emailid Get2- ", userData?.emailid);
    try{
        const response=await axiosClouth.get(`/api/v1/auth/user`, {
            headers:{
                "Authorization": `Bearer ${jwt}`
            }
        });
        const user=response.data;
        //console.log("user-",user)
        dispatch(getUserSuccess(user))
    }catch (error) {
        dispatch(getUserFailure(error.message))
    }
    
}

export const logout=(userData)=>async (dispatch)=>{
    const client = 'client';
    const secret = 'secret';
    const config =  { headers: {'Authorization': `Basic ${Buffer.from(`${client}:${secret}`).toString('base64')}`,
                        'content-type': 'application/json'},
                    };
    try {
        const APIKit_AccessToken = await axiosAuth.post("/oauth2/revoke?token="+userData?.access_token,null, config);
        const APIKit_RefreshToken = await axiosAuth.post("/oauth2/revoke?token="+userData?.refresh_token,null, config);
        const APIKit_idToken = await axiosAuth.post("/oauth2/revoke?token="+userData?.id_token,null, config);
        await axiosAuth.get('/do/logout',{
            headers:{
                'Authorization': `Bearer ${userData?.id_token}`
            }
        }).then((response)=> {
            if (response.data) {
                dispatch({type:LOGOUT, payload:null})
                window.caches.delete();
                window.sessionStorage.clear();
                localStorage.clear();
                //console.log("Email Logout- ", localStorage.getItem("emailid"));
                //console.log("APIKit_AccessToken-",APIKit_AccessToken.status);
                //console.log("APIKit_RefreshToken-",APIKit_RefreshToken.status);
                //console.log("APIKit_idToken-",APIKit_idToken.status);
                //window.location ="http://localhost:9000/oauthsrvr/do/logout";
                window.location ="https://www.enearmart.com/oauthsrvr/do/logout";
            }
        });
    } catch (error) {
        dispatch(getUserFailure(error.message))
    }

    dispatch({type:LOGOUT, payload:null})
    localStorage.clear();
}

export const logoutAdmin=(userData)=>async (dispatch)=>{
    const client = 'admin';
    const secret = 'secret';
    const config =  { headers: {'Authorization': `Basic ${Buffer.from(`${client}:${secret}`).toString('base64')}`,
                        'content-type': 'application/json'},
                    };
    try {
        const APIKit_AccessToken = await axiosAuth.post("/oauth2/revoke?token="+userData?.access_token,null, config);
        const APIKit_RefreshToken = await axiosAuth.post("/oauth2/revoke?token="+userData?.refresh_token,null, config);
        const APIKit_idToken = await axiosAuth.post("/oauth2/revoke?token="+userData?.id_token,null, config);
        await axiosAuth.get('/do/logout',{
            headers:{
                'Authorization': `Bearer ${userData?.id_token}`
            }
        }).then((response)=> {
            if (response.data) {
                dispatch({type:LOGOUT, payload:null})
                window.caches.delete();
                window.sessionStorage.clear();
                localStorage.clear();
                //console.log("Email Logout- ", localStorage.getItem("emailid"));
                //console.log("APIKit_AccessToken-",APIKit_AccessToken.status);
                //console.log("APIKit_RefreshToken-",APIKit_RefreshToken.status);
                //console.log("APIKit_idToken-",APIKit_idToken.status);
                //window.location ="http://localhost:9000/oauthsrvr/do/logout";
                window.location ="https://www.enearmart.com/oauthsrvr/do/logout";
            }
        });
    } catch (error) {
        dispatch(getUserFailure(error.message))
    }

    dispatch({type:LOGOUT, payload:null})
    localStorage.clear();
}

const chgUserManagerRequest=()=>({type:CHG_USER_ROLE_REQUEST});
const chgUserManagerSuccess=(user)=>({type:CHG_USER_ROLE_SUCCESS, payload:user});
const chgUserManagerFailure=(error)=>({type:CHG_USER_ROLE_FAILURE, payload:error});

export const chgUserManager=(reqData)=>async (dispatch)=>{

    dispatch(chgUserManagerRequest())
    try {
        const response = await axiosClouth.put(
          `/api/users/${reqData.userId}/manager`,null,{
            headers:{
                'Authorization': `Bearer ${reqData?.reqJWT}`
            }
          }
        );
        const user = response.data;
        //console.log("user_manager ",user)
        dispatch(chgUserManagerSuccess(user));
      } catch (error) {
        dispatch(chgUserManagerFailure(error.message));
      }
}

const chgUserWholesalerRequest=()=>({type:CHG_USER_ROLE_REQUEST});
const chgUserWholesalerSuccess=(user)=>({type:CHG_USER_ROLE_SUCCESS, payload:user});
const chgUserWholesalerFailure=(error)=>({type:CHG_USER_ROLE_FAILURE, payload:error});

export const chgUserWholesaler=(reqData)=>async (dispatch)=>{

    dispatch(chgUserWholesalerRequest())
    try {
        const response = await axiosClouth.put(
          `/api/users/${reqData.userId}/wholesaler`,null,{
            headers:{
                'Authorization': `Bearer ${reqData?.reqJWT}`
            }
          }
        );
        const user = response.data;
        //console.log("user_manager ",user)
        dispatch(chgUserWholesalerSuccess(user));
      } catch (error) {
        dispatch(chgUserWholesalerFailure(error.message));
      }
}

const chgUserRetailerRequest=()=>({type:CHG_USER_ROLE_REQUEST});
const chgUserRetailerSuccess=(user)=>({type:CHG_USER_ROLE_SUCCESS, payload:user});
const chgUserRetailerFailure=(error)=>({type:CHG_USER_ROLE_FAILURE, payload:error});

export const chgUserRetailer=(reqData)=>async (dispatch)=>{

    dispatch(chgUserRetailerRequest())
    try {
        const response = await axiosClouth.put(
          `/api/users/${reqData.userId}/retailer`,null,{
            headers:{
                'Authorization': `Bearer ${reqData?.reqJWT}`
            }
          }
        );
        const user = response.data;
        //console.log("user_manager ",user)
        dispatch(chgUserRetailerSuccess(user));
      } catch (error) {
        dispatch(chgUserRetailerFailure(error.message));
      }
}

const chgUserUserRequest=()=>({type:CHG_USER_ROLE_REQUEST});
const chgUserUserSuccess=(user)=>({type:CHG_USER_ROLE_SUCCESS, payload:user});
const chgUserUserFailure=(error)=>({type:CHG_USER_ROLE_FAILURE, payload:error});

export const chgUserUser=(reqData)=>async (dispatch)=>{

    dispatch(chgUserUserRequest())
    try {
        const response = await axiosClouth.put(
          `/api/users/${reqData.userId}/user`,null,{
            headers:{
                'Authorization': `Bearer ${reqData?.reqJWT}`
            }
          }
        );
        const user = response.data;
        //console.log("user_manager ",user)
        dispatch(chgUserUserSuccess(user));
      } catch (error) {
        dispatch(chgUserUserFailure(error.message));
      }
}